export interface SettingItem {
	key: string, // key
	icon?: string, // 对应的图标名称
	title: string, // 对应的应用名称
	src: string, // 对应的链接地址
	evtId: string, // 埋点sensorId
}

interface NavigationGroups {
    key: string,
    groupName: string, // 菜单组名称
    groupItems: Array<SettingItem>,
	line?: boolean, // 是否需要下划线
}

const navigationGroups: Array<NavigationGroups> = [
	{
		key: "general",
		groupName: "通用",
		groupItems: [
			{
				key: "general 1",
				icon: "icon_home.png",
				title: "SAP信息管理平台",
				src: "http://portal.cttq.com:53300/irj/portal",
				evtId: "102242"
			},
			{
				key: "general 2",
				icon: "cttq_mail.png",
				title: "企业邮箱",
				src: "https://mail.cttq.com",
				evtId: "102243"
			},
			{
				key: "general 3",
				icon: "cttq_home.png",
				title: "正大天晴",
				src: "http://www.cttq.com",
				evtId: "102244"
			},
			{
				key: "general 4",
				icon: "cttq_college.jpg",
				title: "天晴大学",
				src: "http://px.cttq.com",
				evtId: "102245"
			},
			{
				key: "general 5",
				icon: "cttq_vi.png",
				title: "品牌管理系统",
				src: "https://www.cttqvi.com",
				evtId: "102246"
			},
			{
				key: "general 6",
				icon: "tianshu2.png",
				title: "天书客户端下载",
				src: "https://app.cttq.com/tianshu",
				evtId: "102247"
			},
			{
				key: "general 7",
				icon: "yunpan.png",
				title: "天晴云盘",
				src: "https://pan.cttq.com/web/login.html",
				evtId: "102248"
			},
			{
				key: "general 8",
				icon: "dangan.png",
				title: "档案管理平台",
				src: "http://fms.cttq.com",
				evtId: "102249"
			},
			{
				key: "general 9",
				icon: "kefu.png",
				title: "客服中心",
				src: "https://ainew2prd.cttq.com/cvue/ITService-WebPC/robotChat",
				evtId: "102250"
			},
			{
				key: "general 12",
				icon: "yunyingguanli.png",
				title: "运营管理平台",
				src: "https://ainew2prd.cttq.com/cvue/OPERATION-WebPC/",
				evtId: "102251"
			},
			{
				key: "general 13",
				icon: "xiangmuguanli.png",
				title: "项目管理",
				src: "https://ainew2prd.cttq.com/cvue/ProjectSystem-WebPC/",
				evtId: "102252"
			},
			{
				key: "general 14",
				icon: "cttq_busines.png",
				title: "晴优品",
				src: "https://ainew2prd.cttq.com/cvue/SunnyShop-WebPC/managingDemand",
				evtId: "102253"
			},
			{
				key: "general 15",
				icon: "htzx.png",
				title: "放心签",
				src: "https://ainew2prd.cttq.com/cvue/Sign-WebPC/contractDraftPage",
				evtId: "102254"
			},
			{
				key: "general 16",
				icon: "hr_pc.png",
				title: "人力资源平台",
				src: "https://ainew2prd.cttq.com/cvue/EntryManage-WebPC",
				evtId: "102255"
			},
			{
				key: "general 17",
				icon: "yusuan.png",
				title: "预算管理",
				src: "https://ainew2prd.cttq.com/cvue/BudgetManage-WebPC",
				evtId: "102256"
			},
			{
				key: "general 18",
				icon: "jindie.jpg",
				title: "金蝶ERP",
				src: "https://kderp.cttq.com/ierp/",
				evtId: "102257"
			},
			{
				key: "general 19",
				icon: "quanxian.png",
				title: "权限申请",
				src: "https://ainew2prd.cttq.com/cvue/ACCOUNT-WebPC/permissionApplication/permissionApply",
				evtId: "102258"
			},
			{
				key: "general 20",
				icon: "eam.png",
				title: "设备管理(EAM)",
				src: "https://eam.cttq.com/",
				evtId: "102259"
			},
			{
				key: "general 21",
				icon: "fengkong.svg",
				title: "风控平台",
				src: "https://ainew2prd.cttq.com/cvue/risk-manage-webpc",
				evtId: "102260"
			},
			{
				key: "general 22",
				icon: "jicai.svg",
				title: "集采报销平台",
				src: "https://ainew2prd.cttq.com/cvue/JCBX-WebPC",
				evtId: "102261"
			}
		],
		line: true
	},
	{
		key: "invent",
		groupName: "研发",
		groupItems: [
			{
				key: "invent 1",
				icon: "ctms.png",
				title: "CTMS",
				src: "https://ainew2prd.cttq.com/cvue/CTMS-WebPC",
				evtId: "102262"
			},
			{
				key: "invent 2",
				icon: "eDrug.png",
				title: "eDrug",
				src: "https://ainew2prd.cttq.com/cvue/EDrug-WebPC",
				evtId: "102263"
			},
			{
				key: "invent 3",
				icon: "edcClinflash.svg",
				title: "EDC Clinflash",
				src: "https://edc2.cttq.com/",
				evtId: "102264"
			},
			{
				key: "invent 4",
				icon: "edcecollect.png",
				title: "EDC eCollect",
				src: "https://edc.cttq.com/",
				evtId: "102265"
			},
			{
				key: "invent 5",
				icon: "edcrave.svg",
				title: "EDC RAVE",
				src: "https://login.imedidata.com/login",
				evtId: "102266"
			},
			{
				key: "invent 6",
				icon: "irc.png",
				title: "IRC",
				src: "https://ainew2prd.cttq.com/cvue/IRC-WebPC/",
				evtId: "102267"
			},
			{
				key: "invent 7",
				icon: "ircbfe.png",
				title: "IRC（原）",
				src: "https://irc.cttq.com/",
				evtId: "102268"
			},
			{
				key: "invent 8",
				icon: "shengshenglogistics.png",
				title: "生生物流",
				src: "https://customer.ashsh.com.cn/",
				evtId: "102269"
			},
			{
				key: "invent 9",
				icon: "iwrs.png",
				title: "IWRS（后台）",
				src: "https://ainew2prd.cttq.com/cvue/IWRS-WebPC/login",
				evtId: "102270"
			},
			{
				key: "invent 10",
				icon: "iwrs.png",
				title: "IWRS（前台）",
				src: "https://ainew2prd.cttq.com/cvue/eRandom-WebPC/login",
				evtId: "102271"
			},
			{
				key: "invent 11",
				icon: "erand.png",
				title: "杉互eRand",
				src: "https://erand.odtech.info/",
				evtId: "102272"
			},
			{
				key: "invent 12",
				icon: "ecoding.png",
				title: "eCoding",
				src: "https://ainew2prd.cttq.com/cvue/ECoding-WebPC",
				evtId: "102273"
			},
			{
				key: "invent 13",
				icon: "cde.png",
				title: "CDE登记",
				src: "http://www.chinadrugtrials.org.cn/index.html",
				evtId: "102274"
			},
			{
				key: "invent 14",
				icon: "clinicaltrials.png",
				title: "ClinicalTrials",
				src: "https://clinicaltrials.gov/",
				evtId: "102275"
			},
			{
				key: "invent 15",
				icon: "rms.png",
				title: "RMS",
				src: "https://rms.cttq.com",
				evtId: "102276"
			},
			{
				key: "invent 16",
				icon: "ico_lczx_small.png",
				title: "ePipeline",
				src: "https://ainew2prd.cttq.com/cvue/CTLV-WebPC/menu.html",
				evtId: "102277"
			},
			{
				key: "invent 17",
				icon: "psh.png",
				title: "医药信息共享",
				src: "https://phs.cttq.com",
				evtId: "102278"
			},
			{
				key: "invent 18",
				icon: "ico_medicine_pc.png",
				title: "Cttq Doc",
				src: "https://ainew2prd.cttq.com/cvue/cttqdoc-WebPC",
				evtId: "102279"
			},
			{
				key: "invent 19",
				icon: "cttq_plm.png",
				title: "PLM",
				src: "http://plm.cttq.com/",
				evtId: "102280"
			},
			{
				key: "invent 20",
				icon: "junzhong.png",
				title: "菌种管理平台",
				src: "https://bpm.cttq.com",
				evtId: "102281"
			},
			{
				key: "invent 21",
				icon: "cms.svg",
				title: "CMS",
				src: "https://ainew2prd.cttq.com/cvue/CMS-WebPC",
				evtId: "102282"
			},
			{
				key: "invent 22",
				icon: "carbonnotes.svg",
				title: "碳知笔记",
				src: "https://chemlibrary.cttq.com/login",
				evtId: "102283"
			},
			{
				key: "invent 23",
				icon: "earth.png",
				title: "出口项目平台",
				src: "https://phs.cttq.com",
				evtId: "102284"
			},
			{
				key: "invent 24",
				icon: "etmf.png",
				title: "eTMF",
				src: "https://ainew2prd.cttq.com/cvue/ETMF-WebPC/administration/projectCenter",
				evtId: "103418"
			},
			{
				key: "invent 25",
				icon: "tms.png",
				title: "中集冷云",
				src: "https://newcrm.cccc58.com",
				evtId: "103419"
			}
		],
		line: true
	},
	{
		key: "marketing",
		groupName: "营销",
		groupItems: [
			{
				key: "marketing 1",
				icon: "ehuodong.png",
				title: "e活动",
				src: "https://ainew2prd.cttq.com/cvue/ACT-WebPC",
				evtId: "102285"
			},
			{
				key: "marketing 2",
				icon: "b2b.png",
				title: "药品购销(B2B)",
				src: "http://b2b.cttq.com",
				evtId: "102286"
			},
			{
				key: "marketing 3",
				icon: "crm.svg",
				title: "CRM管理平台",
				src: "https://ainew2prd.cttq.com/cvue/CRM-Platform-WebPC",
				evtId: "102287"
			}
		],
		line: true
	},
	{
		key: "production",
		groupName: "生产",
		groupItems: [
			{
				key: "production 1",
				icon: "gmp.jpg",
				title: "供应商中心",
				src: "https://ainew2prd.cttq.com/cvue/SMS-WebPC/workbench/index",
				evtId: "102288"
			},
			{
				key: "production 2",
				icon: "xq.png",
				title: "采购需求(集采)",
				src: "https://ainew2prd.cttq.com/cvue/QPlan-WebPC",
				evtId: "102289"
			},
			{
				key: "production 3",
				icon: "icon_caigou.png",
				title: "采购商务平台",
				src: "https://ainew2prd.cttq.com/cvue/Bid-WebPC",
				evtId: "102290"
			},
			{
				key: "production 4",
				icon: "srm.png",
				title: "供应商门户",
				src: "https://ainew2prd.cttq.com/cvue/TSP-WebPC",
				evtId: "102291"
			},
			{
				key: "production 5",
				icon: "icon_isc.svg",
				title: "ISC集成供应链",
				src: "https://ainew2prd.cttq.com/cvue/SCP-WebPC",
				evtId: "102332"
			},
			{
				key: "production 6",
				icon: "shebeixunjian.png",
				title: "设备巡点检管理",
				src: "https://eamic.cttq.com/eamic",
				evtId: "102292"
			},
			{
				key: "production 7",
				icon: "work.png",
				title: "工作单",
				src: "https://ainew2prd.cttq.com/cvue/WorkFlowOrder-WebPC/supplier",
				evtId: "102293"
			}
		],
		line: true
	},
	{
		key: "data",
		groupName: "数据",
		groupItems: [
			{
				key: "data 1",
				icon: "swylswdk.png",
				title: "Pharm Data",
				src: "https://ainew2prd.cttq.com/cvue/PharmData-WebPC",
				evtId: "102294"
			},
			{
				key: "data 2",
				icon: "hbbbpt.png",
				title: "合并报表平台",
				src: "https://ainew2prd.cttq.com/cvue/DataFMR-WebPC",
				evtId: "102295"
			},
			{
				key: "data 3",
				icon: "tqlp.png",
				title: "天晴罗盘",
				src: "https://ainew2prd.cttq.com/cvue/DataCompass-WebPC",
				evtId: "102296"
			}
		],
		line: true
	},
	{
		key: "finance",
		groupName: "财税",
		groupItems: [
			{
				key: "finance 1",
				icon: "yanpiapiao11.png",
				title: "验票票",
				src: "https://ainew2prd.cttq.com/cvue/Invoice-WebPC",
				evtId: "102297"
			},
			{
				key: "finance 2",
				icon: "cttq_busines.png",
				title: "晴优品管理后台",
				src: "https://ainew2prd.cttq.com/cvue/SunnyShopAdmin-WebPC",
				evtId: "102298"
			},
			{
				key: "finance 3",
				icon: "settlement.svg",
				title: "结算系统",
				src: "https://ainew2prd.cttq.com/cvue/Settle-WebPC",
				evtId: "102299"
			},
			{
				key: "finance 4",
				icon: "jiqiren.svg",
				title: "天晴机器人管理平台",
				src: "https://ainew2prd.cttq.com/cvue/ITService-WebPC",
				evtId: "102300"
			},
			{
				key: "finance 5",
				icon: "qingshanji.svg",
				title: "晴闪寄快递管理平台",
				src: "https://ainew2prd.cttq.com/cvue/ExpressCenter-WebPC/dataMana/expressOrder",
				evtId: "102301"
			},
			{
				key: "finance 6",
				icon: "shundianpass.svg",
				title: "顺店通",
				src: "https://buac.sf-express.com/login?redirect_uri=https%3A%2F%2Funited-store-ms.sf-express.com%2F#/authCas",
				evtId: "102302"
			},
			{
				key: "finance 7",
				icon: "hireimbursement.svg",
				title: "嗨报销",
				src: "https://ainew2prd.cttq.com/cvue/HBX-WebPC",
				evtId: "102303"
			},
			{
				key: "finance 8",
				icon: "capture.svg",
				title: "请款",
				src: "https://ainew2prd.cttq.com/cvue/Loan-WebPC/loan",
				evtId: "102304"
			},
			{
				key: "finance 9",
				icon: "hireimbursement.svg",
				title: "嗨报销运营管理平台",
				src: "https://ainew2prd.cttq.com/cvue/ExpAdmin-WebPC/voucher",
				evtId: "102305"
			},
			{
				key: "finance 10",
				icon: "fenjiancenter.svg",
				title: "分拣中心",
				src: "https://ainew2prd.cttq.com/cvue/Sorting-WebPC/basicSetting/position",
				evtId: "102306"
			}
		],
		line: true
	},
	{
		key: "link",
		groupName: "友情链接",
		groupItems: [
			{
				key: "link 1",
				title: "研发中心",
				src: "http://www.cttq.com/innovate/yan-fa-ping-tai.htm",
				evtId: "102307"
			},
			{
				key: "link 2",
				title: "南京正大天晴",
				src: "http://www.njcttq.com/",
				evtId: "102308"
			},
			{
				key: "link 3",
				title: "正大清江",
				src: "http://www.ctqjph.com/",
				evtId: "102309"
			},
			{
				key: "link 4",
				title: "正大丰海",
				src: "http://www.ctfh.com.cn/",
				evtId: "102310"
			},
			{
				key: "link 5",
				title: "江苏农垦",
				src: "http://www.jsnk.com.cn/",
				evtId: "102311"
			},
			{
				key: "link 6",
				title: "公司新闻",
				src: "http://www.cttq.com/news/xin-wen-zi-xun-list-0.htm",
				evtId: "102312"
			},
			{
				key: "link 7",
				title: "爱心基金",
				src: "http://fund.cttq.com/zh-cn/",
				evtId: "102322"
			}
		]
	}
];

export { navigationGroups };
